// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'wallet-solid';

export const Component = () => (
  <path d='M23.079 6.891H22.6V2.964c0-.526-.191-1.005-.575-1.389A1.917 1.917 0 0 0 20.635 1H4.449c-.91 0-1.724.335-2.394 1.005C1.335 2.675 1 3.49 1 4.448v17.624c0 .431.144.766.431 1.054.288.287.623.431 1.054.431H23.08c.431 0 .766-.144 1.054-.431.287-.288.431-.623.431-1.054v-4.406H19.68a.977.977 0 0 1-.719-.288.943.943 0 0 1-.287-.67v-2.97c0-.239.096-.479.287-.67a.976.976 0 0 1 .719-.288h4.885V8.374c0-.431-.144-.766-.431-1.054a1.408 1.408 0 0 0-1.054-.43v.001Zm-2.443-2.968v2.97H4.256a1.772 1.772 0 0 1-.287-1.006c0-.527.191-1.006.575-1.39a1.917 1.917 0 0 1 1.389-.574h14.703Zm-.479 9.818h4.406v2.97h-4.406c-.335 0-.479-.192-.479-.527V14.22c0-.335.144-.479.479-.479Z' />
);

export const viewBox = '0 0 25 25';
